var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-group',{ref:"mygroup",attrs:{"config":{
             name: _vm.obj.id,
              x : _vm.obj.position.x,
              y : _vm.obj.position.y,
              }},on:{"dragend":_vm.handleDragEnd,"dragmove":_vm.handleDragMove}},[_c('v-circle',{attrs:{"config":{
                    x: 0,
                    y: 0,
                    Radius: 120,
                    groupRef: _vm.obj.id,
                    stroke: '#8992a5',
                    fill:_vm.selectionned,
                    strokeWidth: _vm.hasChildren,
                    listening:false,
                    dash:[10,5]
                    }}}),(_vm.hasChildren>0)?_c('v-text',{attrs:{"config":{
                              x : 130,
                              y:-16,
                              fill: '#8992a5',
                              text: _vm.getChildrenText,
                              fontSize:34,
                              fontStyle:'bold',
                                fontWeight:900,
                              }}}):_vm._e(),_c('v-rect',{ref:"circle",attrs:{"name":"circle","config":{
                              x : -100,
                              y: -50,
                              width:200,
                              height:100,
                              groupRef: _vm.obj.id,
                              radius: 50,
                              fill: 'white',
                              stroke: _vm.getDialStrokeColor,
                              strokeWidth: _vm.getDialStorke,
                              cornerRadius: _vm.getDialRadius,
                              shadowColor: 'black',
                              shadowBlur: 10,
                              shadowOffset: { x: -5, y: 5 },
                              shadowOpacity: this.opac,
                              draggable: _vm.imAlive,
                              }},on:{"dragstart":_vm.handleDragStart,"mouseenter":_vm.cursorMove,"mouseleave":_vm.cursorDefault,"click":_vm.editTask}}),_c('v-text',{attrs:{"config":{
                              x : -200,
                              y: -75,
                              width:400,
                              fill: 'black',
                              text: _vm.labelUpper,
                              fontSize:24,
                              fontStyle:'bold',
                              align:'center',
                              }}}),(_vm.isDialogue)?_c('v-text',{attrs:{"config":{
                              x : -160,
                              y:-25,
                              fill: _vm.getDialColor,
                              text: _vm.getDialIcon,
                              fontSize:54,
                              fontStyle:'bold',
                              fontFamily:'FontAwesome',
                              }}}):_vm._e(),(_vm.nothingIsMoving)?_c('v-text',{attrs:{"config":{
                              x : -90,
                              y: -43,
                              width:180,
                              fill: 'black',
                              text: _vm.getShortDesc,
                              fontSize:12,
                              fontStyle:'bold',
                              padding:3,
                              align:'left',
                              listening:false,
                              }}}):_vm._e(),(_vm.nothingIsMoving)?_c('v-image',{attrs:{"config":{
                              x : 104,
                              y: -51,
                              image:_vm.imgClose,
                              }},on:{"click":_vm.confirmDelete}}):_vm._e(),(_vm.nothingIsMoving)?_c('v-image',{attrs:{"config":{
                              x : 104,
                              y: -14,
                              image:_vm.imgDeeper,
                              }},on:{"click":_vm.goDeeper}}):_vm._e(),(_vm.nothingIsMoving)?_c('v-image',{attrs:{"config":{
                              x : -9,
                              y: 35,
                              image:_vm.imgAdd,
                              }},on:{"click":_vm.addResultat}}):_vm._e(),_vm._l((_vm.resultats),function(thing){return _c('resultat',{key:thing.id,attrs:{"res":thing},on:{"reloadRes":_vm.updateResultats,"linkChange":_vm.linkChange}})}),_c('v-circle',{ref:"requis",attrs:{"name":"Requis","config":{
                                    x: 0,
                                    y: -95,
                                    Radius: 15,
                                    groupRef: _vm.obj.id,
                                    fill: '#E6A23C',
                                    stroke: '#606266',
                                    strokeWidth: 1,
                                    listening:true,
                                    }},on:{"dragenter":_vm.collisionStart,"dragout":_vm.collisionStop}})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }